import {NgModel} from 'model/ngModel';

export const ProxiedGoogleLocationModel = NgModel.extend({
    _name : 'ProxiedGoogleLocationModel',
});
